import USER_ENDPOINTS from './userEndpoints';
import OVERVIEW_ENDPOINTS from './overviewEndpoints';
import MANAGEMENT_ENDPOINT from './managementEndPoints';
import INSIGHTS_ENDPOINT from './insightsEndPoints';
import ACCOUNTS_ENDPOINTS from './accountsEndpoints';
import MEDIA_PLAN_GALLERY_ENDPOINTS from './mediaPlanGalleryEndPoint';
import CREATIVE_ANALYTICS_END_POINTS from './creative_analytics';
import LAUNCHER_ENDPOINT from './launcherEndPoints';
import APP_ENDPOINTS from './appEndPoints';
import CONNECTED_BRANDS_ENDPOINTS from './connectedBrandsEndpoints';
import CONNECTED_ACCOUNTS_ENDPOINTS from './connectedAccountsEndpoints';

const END_POINTS = {
  APP: { ...APP_ENDPOINTS },
  USER: { ...USER_ENDPOINTS },
  OVERVIEW: { ...OVERVIEW_ENDPOINTS },
  MANAGEMENT: { ...MANAGEMENT_ENDPOINT },
  INSIGHTS: { ...INSIGHTS_ENDPOINT },
  ACCOUNTS_ENDPOINTS: { ...ACCOUNTS_ENDPOINTS },
  CREATIVE_ANALYTICS: { ...CREATIVE_ANALYTICS_END_POINTS },
  MEDIA_PLAN_GALLERY: { ...MEDIA_PLAN_GALLERY_ENDPOINTS },
  LAUNCHER: { ...LAUNCHER_ENDPOINT },
  CONNECTED_BRANDS: { ...CONNECTED_BRANDS_ENDPOINTS },
  CONNECTED_ACCOUNTS: { ...CONNECTED_ACCOUNTS_ENDPOINTS }
};

export default END_POINTS;
